import type { NFLMismatch } from '@pff-consumer/schema'

const mismatchIdsToFilter: string[] = ['23105#RT_LE_run#false', '23110#SWR_SCB#true', '23106#LWR_RCB#true']

export const filterMismatches = (mismatches: NFLMismatch[]): NFLMismatch[] => {
  return mismatches.splice(0, 6).filter((mismatch) => !mismatchIdsToFilter.includes(mismatch.id))
}
